@if(!isKpiCardZero) {
<div
	class="card-container"
	[ngStyle]="{ cursor: isOnGlobalDashboard ? 'pointer' : 'auto' }"
	[ngClass]="{
		'hovered-style': selected,
		loading: showLoadingAnimation,
		missing: isMissingKpi
	}"
	(click)="kpiSelected.emit(kpiName)"
	[attr.data-test]="getDataTestValue() + '-card'"
>
	@if(!showLoadingAnimation) {
	<div class="type-container">
		<div class="info-container">
			<span class="type" [attr.data-test]="getDataTestValue()">{{ kpiName }}</span>
			<span class="number" [attr.data-test]="getDataTestValue() + '-card-value'">{{
				kpiCard.kpiType[kpiName].count
			}}</span>
		</div>
		<div class="icon-container" [ngClass]="{ missing: isMissingKpi }">
			<app-icon
				name="{{ kpiCard.icon }}"
				[ngClass]="{ bank: kpiCard.icon === 'bank-figma', transactions: kpiCard.icon === 'wallet-add' }"
				[lineWidth]="'1px'"
				[size]="'26'"
				[color]="isMissingKpi ? 'var(--color-kpi-card-missing)' : 'var(--color-kpi-card-failed)'"
			></app-icon>
		</div>
	</div>
	<div class="percentage-container">
		<div class="range">
			<span>0%</span>
			<span>100%</span>
		</div>
		<div class="bar" [attr.data-test]="getDataTestValue() + '-bar-value'">
			<div class="filled" [ngStyle]="{ width: kpiCard.kpiType[kpiName].percentage + '%' }"></div>
		</div>
	</div>
	}
</div>
}
